module.exports = __webpack_public_path__ + "img/coroa.cc848ebd.png";